<template>
	<div class="innerBox">
		<h2 class="mb-4">Formulir Work Order</h2>

		<component
			:is="'page' + page"
			:data="data"
			:carType="carType"
			:page="page" 
			:checklistSettings="checklistSettings"
			@emitCQ="inputCQ"
			:merek="merek"
			v-on:nextPage="nextPage"
			:title="'Formulir Work Order'"
			:apiLoading="apiLoading"
			:skip="skip"
			@mergeWo="mergeWo"
			:allowMerge="true"
		>

		</component>

		<upload-image
			v-if="modal.show"
			:title="modal.title"
			:endpoint="modal.endpoint"
			@onResponse="createWorkOrder"
			@closeModal="modal.show = false"
			:type="modal.type"
			:show_description="true"
			
		></upload-image>
	</div>
	
</template>

<script>
	import page1 from './v2/workOrderFormPage/newPage1'
	// import './workOrderFormPage/sedan.css'
	// import './workOrderFormPage/minibus.css'
	import UploadImage from '@/components/modal/uploadImage'
	import env from '@/env'

	import moment from 'moment'
	// const translate = require('@vitalets/google-translate-api');

	export default {
		data () {
			let today = new moment().format('MMM, DD YYYY')
			return {
				last_km  : '',
				skip : true,
				page: 1,
				apiLoading : false ,
				modal : {
					show : false,
					title : 'Upload Gambar Depan',
					endpoint : env.urlStart + '/api/v1/workorder/steps/upload',
					type : null
				},
				
				merek : '',
				carType : 'sedan',
				customerRequest : '',
				data: {
					CSO: '',
					serviceType : 'Mobil Menginap',
					customer: {
						name: '',
						alias: '',
						phone_number: '',
						created_at: today,
						last_date: today,
						ktp : '',
						ktp_img : '',	
					},
					customer_car: {
						"chassis_number": '',
						"engine_number": '',
						"registration": '',
						colour : '',
						car_color_id : null,
						car_id: null,
						"current_km": '',
						"last_km": '0',
						"year": '',
						"brand": '',
						"type": '',
						stnk_img : '',
						// price : null,
						model : null,
						sim_img : ''
						
					}
				},
				checklistSettings: null
			}
		},
		watch: {
			'data.customer_car.model' : function () {
				
				this.data.customer_car.car_id = this.data.customer_car.model.id
			},
			'data.customer_car.colour' : function () {
				this.data.customer_car.car_color_id = this.data.customer_car.colour.id
			},
		},
		components : {
			page1,
			UploadImage
		},
		mounted () {
			this.data.form_code = this.$route.params.form_code
			this.getWoDetails()
		},
		methods : {
			inputCQ(message) {
				this.customerRequest = message
				console.log(this.customerRequest)
			},
			mergeWo (form_code , serviceType, customer_id , customer_car) {
				this.$http.patch(`/api/v1/workorder/merge?from=${this.$route.params.form_code}&to=${form_code}&serviceType=${serviceType}&customer_id=${customer_id}` ,{
					customer_car : customer_car
				}
				)
				.then((resp) => {
					this.$store.dispatch('triggerAlert' , [true , 'Merge Work Order Done.'])
					this.$router.push({name : 'WorkOrderForm'})
				})
				.catch((err) => {
					console.log(err)
					this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong.'])
				})
			},
			getWoDetails() {
                this.$http.get(`/api/v1/workorder/${this.data.form_code}/detail`)
                    .then(async(resp) => {
                        var data = resp.data.data;
						this.data.customer_car.registration = data.registration
						this.data.customer_car.last_km = data.condition.last_km
						this.data.customer_car.current_km = data.current_km
						this.last_km = data.condition.last_km
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
			nextPage (check) {
				this.updateForm()
					
			},
			async updateForm () {
				let data = JSON.parse(JSON.stringify(this.data))
				console.log(data)
				delete data.customer_car.brand
				delete data.customer_car.type
				delete data.customer.created_at
				delete data.customer.last_date
				delete data.customer_car.colour
				// delete data.customer_id
				delete data.customer_car.model
				if(!data.customer.email) data.customer.email = ''
				data.skip = false
				data.customer_id = data.customer.customer_id

				data.customer_car_chassis_number = data.customer_car.chassis_number
				data.customer.ktp = data.customer.ktp.split(" ").join("")

				data.customer_car.chassis_number = data.customer_car.chassis_number.trim()
				data.customer_car.engine_number = data.customer_car.engine_number.trim()
				data.customer.email = data.customer.email.trim();

				data.customer_car.last_km = typeof this.last_km == 'string' ? parseInt(this.last_km.split(',').join('')) : this.last_km
				data.customer_car.current_km = typeof this.last_km == 'string' ? parseInt(this.last_km.split(',').join('')) : this.last_km

				console.log(this.last_km)
				// if(data.customer_car.current_km)
				// 	data.customer_car.current_km = data.customer_car.last_km = parseInt(data.customer_car.current_km.split(",").join(""))
				// else {
				// 	data.customer_car.last_km = 0
				// 	data.customer_car.current_km = 0
				// }
				// data.finishDate = new moment().format('Y-MM-DD')
				data.CSO = this.$store.state.userData.userData.name

				// If Customer Quotation
				if(this.data.temp_code) {
					try {
						data.finishDate = new moment().format('Y-MM-DD')
						
						// Create Forms
						let resp = await this.$http.post('/api/v1/workorder' , {data : data })
						
						let responseMerge = await this.$http.patch(`/api/v1/workorder/merge?from=${data.temp_code}&to=${data.form_code}&serviceType=${data.serviceType}&customer_id=${data.customer_id}`)


						this.$store.dispatch('triggerAlert' , [true , 'Work Order Telah Dibuat Dengan Kode CQ ' + data.form_code]);
						this.$router.push({name : 'WorkOrderForm'})
					}
					catch(err) {
						console.log(err)
						this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong when Creating WorkOrder' , err])
					}
				}
				else {
					this.$http.patch('/api/v1/workorder/' + this.data.form_code , {data : data})
					.then((resp) => {
						this.$store.dispatch('triggerAlert' , [true , 'Data Berhasil Disimpan!'])
						this.$router.push({name : 'WorkOrderDetail', query: {wo:this.data.form_code.replace(/"/g, "")}})
					})
					.catch((err) => {
						console.log(err.response)
						let errMessage = err.response.data.data
						if(typeof errMessage == 'string') {
							if(errMessage.includes('registration'))
								errMessage = errMessage.replace('registration' , 'Nomor Polisi Mobil')

							this.$store.dispatch('triggerAlert' , [false , errMessage])
							this.apiLoading = false
						}
						else if(errMessage.nativeError) {
							this.$store.dispatch('triggerAlert' , [false , errMessage.nativeError.sqlMessage])
						}
						else {
							let keys = Object.keys(errMessage)
							let arr = []
							for(var i = 0 ; i < keys.length ; i++) {
								let message = errMessage[keys[i]][0].message
								arr.push(`${this.translate(keys[i])} ${message}`)

							}
							this.$store.dispatch('triggerAlert' , [false , arr])
							this.apiLoading = false
						}
					})
				}

				
			},
			translate(text) {
				let obj = {
					chassis_number : 'Nomor Rangka',
					engine_number : 'Nomor Mesin',
					registration : 'Nomor Polisi Mobil',
					address : 'Alamat'
				}

				return obj[text] ? obj[text] : text
			}
		}
	}
</script>

<style scoped>
	.Aligner {
	display: flex;
	align-items: center;
	justify-content: center;
	}
  
</style>

